/* eslint-disable no-unused-vars */
/* eslint-disable no-shadow */

export enum ContentRoutes {
  Routes = 'routes',
  Materials = 'materials',
  Containers = 'containers',
  Regionals = 'regionals',
  Users = 'users',
  SuperUsers = 'superusers',
  Roles = 'roles',
  Company = 'company',
  Companies = 'companies',
  Project = 'projects',
  Partner = 'partners',
  Checklists = 'checklists',
  Vehicles = 'vehicles',
  AccessoryTypes = 'accessory_types',
  VehicleAccessories = 'vehicle_accessories',
  Dispatch = 'dispatch',
  Drivers = 'drivers',
  Trainings = 'trainings',
  UsersTrainings = 'users/trainings',
  QRCode = 'qr_code'
}
